import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Tache } from 'src/app/shared/models/tache';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';
import { request } from 'http';
import { reference } from '@popperjs/core';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-detail-tache',
  templateUrl: './detail-tache.component.html',
  styleUrl: './detail-tache.component.scss'
})

export class DetailTacheComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;
  submitted: boolean;
  tacheData: any = [];
  modalRef: NgbModalRef | null = null;
  @ViewChild('tacheModal') modalContent: TemplateRef<any>;
  @ViewChild('tacheModalProgress') modalContent1: TemplateRef<any>;

  itemToDelete!: any;
  itemTache: Tache = new Tache();
  sousActivite: any = {};
  paginatedItems: any[] = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  paginatedItemsProgres: any[] = [];
  first1: number = 0;
  rows1: number = 10;
  totalRecords2: number = 0;

  // Nombre total d'éléments
  isLoading: boolean = false;
  fitreTache: any;

  isDisabled: boolean = false;
  tauxfinal: any;
  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxloader: NgxUiLoaderService,
    public activeModal: NgbActiveModal,
    private FecthDataService: FecthDataService

  ) { }

  direction: any ;
  ngOnInit(): void {
    this.direction = this.localstorage.getRefTacheToExecution();
    this.sousActivite = this.localstorage.getSousActiviteItem();
    this.fetchTachesList();
  }


  fetchTachesList() {
    this.fitreTache = this.localstorage.getFilteredTache();

    this.isLoading = true;

    this.paramservice.getTacheListBySousActiviteItem(this.sousActivite.reference,this.direction).subscribe(
      (response: any) => {
        this.isLoading = false;
        let tacheData = response.data;

        console.log("tacheData", tacheData);

        // Application du filtre en fonction du type
        if (this.fitreTache === 'arealiser') {
          tacheData = tacheData.filter(item => item.est_realise === false);

        } else if (this.fitreTache === 'realise') {
          tacheData = tacheData.filter(item => item.est_realise === true);

        } else if (this.fitreTache === 'retard') {
          tacheData = tacheData.filter(item => !item.est_realise && new Date(item.date_fin) < new Date());

        }

        this.tacheData = tacheData;
        this.totalRecords = this.tacheData.length;
        this.updateTache();
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  //detail modal
  detailModal(tacheItem: Tache) {
    console.log("tacheItem", tacheItem);
    //console.log("this.itemTache.taux_final", this.itemTache.taux_final);
    //this.tauxfinal = tacheItem.taux_final;
    //console.log("this.tauxfinal ", this.tauxfinal);
     this.isDisabled = false;
    this.itemTache = new Tache();
    this.itemTache.code = tacheItem.code;
    this.itemTache.libelle = tacheItem.libelle;
    this.itemTache.direction_id = tacheItem.direction_id;
    this.itemTache.reference = tacheItem.reference;
    this.itemTache.reference_user = tacheItem.reference_user;
    this.itemTache.poids = tacheItem.poids;

    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    this.itemTache.date_enregistrement = `${day}/${month}/${year}`;
    this.localstorage.saveTacheItem(tacheItem);


    const modalRef = this.modalService.open(this.modalContent, {
      backdrop: 'static',
      centered: true,
      size: 'xl'
    },);
  }//end detailModal


  Modal() {
    this.itemTache = new Tache();


    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    this.itemTache.date_enregistrement = `${day}/${month}/${year}`;


    const modalRef = this.modalService.open(this.modalContent, {
      backdrop: 'static',
      centered: true,
      size: 'xl'
    },);
  }//end detailModal

  onEntierementRealiseeChange(): void {
    if (this.itemTache.entierementRealisee) {
      this.itemTache.pourcentageRealisation = 100;
      this.isDisabled = true;
    } else {
      this.itemTache.pourcentageRealisation = 0;
      this.isDisabled = false;

    }

    this.calculerPoidsRealise();
  }

  onPourcentageChange(): void {
    this.calculerPoidsRealise();
  }

  calculerPoidsRealise(): void {
    const poids = this.itemTache.poids || 0;
    const pourcentage = this.itemTache.pourcentageRealisation || 0;

    this.itemTache.poidsrelaliseenpourcentage = (poids * pourcentage) / 100;
  }



  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.itemTache.preuve_realisation = file;
    }
  }

  //enregistre sous activite
  saveTacheToSousActiviter(modal: any) {
    if (!this.itemTache.canUpdateForRealisation()) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.itemTache.getErrorMessage() });
      return;
    }
    //console.log("this.itemTache.pourcentageRealisation", this.itemTache.pourcentageRealisation);
    //console.log("this.itemTache.taux_final", this.itemTache.taux_final);


    // if (this.itemTache.pourcentageRealisation + this.tauxfinal > 100) {
    //   this.messageService.add({
    //     severity: 'info',
    //     summary: Constant.suiviTitle,
    //     detail: "La somme du pourcentage renseigné et du taux de réalisation précédent dépasse 100%."
    //   });
    //   return;
    // }


    let savedTacheItem = this.localstorage.getTacheItem();

    const formData = new FormData();
    this.ngxloader.start();
    formData.append('reference', savedTacheItem.reference);
    formData.append('code', savedTacheItem.code);
    formData.append('libelle', savedTacheItem.libelle);
    formData.append('poids_temoin', this.itemTache.poids);
    formData.append('date_enregistrement', this.itemTache.date_enregistrement);
    formData.append('date_realisation', this.itemTache.date_realisation);
    formData.append('observation', this.itemTache.observation);
    formData.append('pta_activite_id', this.sousActivite.reference);
    formData.append('taux_realisation', this.itemTache.pourcentageRealisation);
    formData.append('poids_realise', this.itemTache.poidsrelaliseenpourcentage);

    if (this.fitreTache === "arealiser") {

      savedTacheItem.est_realise = true;
      formData.append('est_realise', savedTacheItem.est_realise);

    }
    if (this.fitreTache === "realise") {
      savedTacheItem.est_realise = false;
      formData.append('est_realise', savedTacheItem.est_realise);

    }

    if (this.fitreTache === "retard") {
      savedTacheItem.est_realise = true;
      formData.append('est_realise', savedTacheItem.est_realise);

    }

    // check file
    if (this.itemTache.preuve_realisation) {
      formData.append('file', this.itemTache.preuve_realisation);
    }

    this.paramservice.saveSousActiviteDirection(this.itemTache.reference, formData).subscribe(
      (response: any) => {
        this.ngxloader.stop();
        // Handle error status from backend
        if (response.status === 'error') {
          this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: response.message });
          return;
        }
        this.fetchTachesList();
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        modal.close(); // Ferme le modal spécifique
        return;
      },
      (error: any) => {
        this.ngxloader.stop();
        // Extract error message from response - handle different error formats
        let errorMessage = "Une erreur est survenue";

        // Try to extract error message from various possible locations
        if (error.error) {
          // Case 1: error.error is an object with message property
          if (typeof error.error === 'object') {
            if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.msg) {
              errorMessage = error.error.msg;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            } else if (error.error.data && error.error.data.message) {
              errorMessage = error.error.data.message;
            }
          }
          // Case 2: error.error is a string
          else if (typeof error.error === 'string') {
            try {
              const parsed = JSON.parse(error.error);
              errorMessage = parsed.message || parsed.msg || error.error;
            } catch {
              errorMessage = error.error;
            }
          }
        } else if (error.message) {
          errorMessage = error.message;
        } else if (error.msg) {
          errorMessage = error.msg;
        } else if (typeof error === 'string') {
          errorMessage = error;
        }

        // Check if error response has status: "error" in the body
        if (errorMessage === "Une erreur est survenue" && error.status === 0) {
          errorMessage = "Impossible de se connecter au serveur. Veuillez vérifier votre connexion.";
        }

        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: errorMessage });
      }
    );
  }

  close() {
    this.modalService.dismissAll()
  }



  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;

    this.updateTache();
  }

  updateTache() {
    const start = this.first;
    const end = this.first + this.rows;
    this.paginatedItems = this.tacheData.slice(start, end);
  }

  //annuler tache
  annulerTacheRealiser(event: any) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir annuler cette tâche :' + event.libelle + '?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        const request = {
          "tache_id": event.reference,
        }
        this.ngxloader.start();
        this.paramservice.annulerTache(request).subscribe(
          (response: any) => {
            this.ngxloader.stop();
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
            this.fetchTachesList();
            this.FecthDataService.notifySeriviceCreated();
            this.ngxloader.stop();
          },
          (error) => {
            this.ngxloader.stop();
          },
        )
      },
    });
  }//end annulerTacheRealiser


  // griser le button reliser 
      
  isFirstNonRealised(index: number): boolean {
  const firstIndex = this.paginatedItems.findIndex(item => item.est_realise === false);
  return index === firstIndex;
}
  //end

  detailsProgItems: any = [];
  detailModalProgressTache(tacheProgressItem: any) {

    this.detailsProgItems = tacheProgressItem;
    this.totalRecords2 = this.detailsProgItems.pta_detail_realisation_taches.length;
    this.updateTacheProgress()
   // console.log("this.detailsProgItems", this.detailsProgItems);

    const modalRef = this.modalService.open(this.modalContent1, {
      backdrop: 'static',
      centered: true,
      size: 'xl'
    },);

  }
  onPageChangeProgress(event: any) {
    this.first1 = event.first;
    this.rows1 = event.rows;

    this.updateTacheProgress();
  }

  updateTacheProgress() {
    const start = this.first1;
    const end = this.first1 + this.rows1;
    this.paginatedItemsProgres = this.detailsProgItems?.pta_detail_realisation_taches.slice(start, end);
  }


    annulerTacheRealiserProgres(event: any) {
     this.confirmationService.confirm({
       target: event.target as EventTarget,
       message: 'Êtes-vous sûr de vouloir annuler la réalisation partiel de cette tâche ?',
       header: 'Confirmation',
       icon: 'pi pi-exclamation-triangle',
       acceptIcon: 'pi pi-check',
       rejectIcon: 'pi pi-times',
       rejectButtonStyleClass: 'p-button-text',
       acceptLabel: 'Oui',
       rejectLabel: 'Non',
       accept: () => {
         const request = {
           "tache_id": event.reference,
         }
         this.ngxloader.start();
         this.paramservice.annulerTache(request).subscribe(
           (response: any) => {
            this.ngxloader.stop();
             this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
             this.fetchTachesList();
             this.FecthDataService.notifySeriviceCreated();

             this.ngxloader.stop();
           },
           (error) => {
             this.ngxloader.stop();
           },
         )
       },
     });
   }
  //
}
